import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, FOUNDATION_ROUTES, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { HPMSOnSubmitTermUse, HpmsTermServiceApi } from '@philips-emr/hpms-provider-accreditation-components';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

interface Term {
  nrSequence: number;
}

@Controller({ fragment: 'assign-term-use-modal', component: 'modal-assign-term-use' })
class AssignTermUseModalController extends BaseController {

  @Inject('fetch-hpms-term-use')
  private fetchTermoUso: FetchAPI;

  @Inject('hpms-term-service')
  private checkTerm: HpmsTermServiceApi;

  @OnMount('modal-assign-term-use')
  onMount(): void {
    const { nrSeqTermo } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqTermo });
    const nrSeqValid = nrSeqTermo !== 'undefined';
    this.checkTerm.setEnabled(nrSeqValid);
    if (nrSeqValid) {
      this.fetchTermoUso.setParameters({ nrSeqTermo });
      this.fetchTermoUso.forceFetch();
    }
  }

  @OnClose('modal-assign-term-use')
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  @HPMSOnSubmitTermUse('hpms-term-service')
  onSubmitTermUse(): void {
    const { nrSeqUser, nrSeqTerm } = this.historyService.getCurrentRouteParams();
    if (nrSeqTerm !== 'undefined') {
      void HttpService.put(Endpoint.PUT.CONFIRM_READ_TERM_USE, { nrSeqTerm }).then(() => {
        void this.checkPrivacyWarning(Number(nrSeqUser));
      });
    }
  }

  private async checkPrivacyWarning(nrSeqUser: number): Promise<void> {

    await HttpService.get(Endpoint.GET.CHECK_PRIVACY_WARNING, { nrSeqUser }).then(async respCheckAviso => {
      const { nrSequence } = respCheckAviso.body as Term;
      if (!nrSequence) {
        await HttpService.get(Endpoint.GET.PRIVACY_WARNING_CURRENT, { nrSeqUser }).then(respAviso => {
          const { nrSequence } = respAviso.body as Term;
          if (nrSequence) {
            this.context.set({ nrSeqAviso: nrSequence });
            this.historyService.push(Route.ASSIGN_PRIVACY_WARNING, { nrSeqAviso: nrSequence });
          } else {
            this.historyService.push(APPLICATION_ROUTES.PROVIDER_ACCREDITATION, { nrSeqUser });
          }
        });
      } else {
        this.historyService.push(APPLICATION_ROUTES.PROVIDER_ACCREDITATION, { nrSeqUser });
      }
    });
  }

}

export default AssignTermUseModalController;
